import {UploadFileRequest, UploadFileResponse} from "../model/uploadFile";
import {UploadFileDataSource} from "./uploadFileDataSource";
import moment from "moment";

export class UploadFileService {
    constructor(private dataSource: UploadFileDataSource) {}

    async uploadFile(request: UploadFileRequest): Promise<UploadFileResponse> {
        // ファイル名を生成
        const timestamp = moment().unix();
        const originalName = request.file.name.split(".")[0];
        const fileExtension = request.fileType || request.file.name.split(".").pop();
        const fileName = `${timestamp}.${originalName}`;

        if (!request.directory) {
            request.directory = `upload/clinic_${request.clinicId}/temp/${fileExtension}`;
        }

        const formData = new FormData();
        formData.append('file', request.file);
        formData.append('clinicId', request.clinicId);
        formData.append('fileType', fileExtension || '');
        formData.append('fileName', fileName);
        formData.append('directory', request.directory);

        return await this.dataSource.uploadFile(formData);
    }
}